import { toast } from '@systemeio/ui'
import { NewsletterCurrentEmailErrorsInterface } from 'modules/newsletters/single/types/error-response-content-interface'
import { Dispatch, SetStateAction } from 'react'
import { EmailErrorType } from 'shared/components/dashboard-mail-editor/types/email-interface'

export const setNewsletterEmailErrors = (
  setErrors: Dispatch<SetStateAction<EmailErrorType>>,
  currentEmail?: NewsletterCurrentEmailErrorsInterface,
) => {
  setErrors(prev => ({
    ...prev,
    body: currentEmail?.body?.join(''),
    fromEmail: currentEmail?.fromEmail?.join(''),
    fromName: currentEmail?.fromName?.join(''),
    subject: currentEmail?.subject?.join(''),
    previewText: currentEmail?.previewText?.join(''),
    attachments: currentEmail?.attachments?.join(''),
  }))
  if (currentEmail?.fromEmail) toast.error(currentEmail?.fromEmail?.join(''))
}
